import { Mark } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    customStyleMark: {
      /**
       * Apply or remove a custom inline style mark by key.
       */
      setInlineStyle: (styleKey: string | null) => ReturnType;
    };
  }
}

const CustomStyleMark = Mark.create({
  name: 'customStyleMark', // There might be `customStyleNode` in future
  inclusive: true,

  addAttributes() {
    return {
      customStyleKey: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-custom-style') || null,
        renderHTML: (attrs) => (attrs.customStyleKey ? { 'data-custom-style': attrs.customStyleKey } : {}),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-custom-style]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0];
  },

  addCommands() {
    return {
      setInlineStyle:
        (styleKey) =>
        ({ commands }) => {
          if (!styleKey) {
            return commands.unsetMark(this.name);
          }
          return commands.setMark(this.name, { customStyleKey: styleKey });
        },
    };
  },
});

export default CustomStyleMark;
